import { Routes } from "@angular/router";
import { COMMON_GUARD_OPTIONS } from "@app/shared/auth/constants/permissions.constant";
import { IAuthGuardOptions } from "@app/shared/auth/interfaces/auth.interface";
import { OcrQuotaitonExpirationSettingsRoutePaths } from "./ocr-quotaiton-expiration-settings-route-path";
import { ocrQuotationExpirationSettingsResolver } from "./resolvers/get-ocr-quotation-expiration-settings.resolver";
import { AuthGuard } from "@app/shared/auth/guards/auth.guard";
import { ExpirationSettingsRoutePaths } from "@app/applications/settings/domains/expiration-settings/expiration-settings-route-path";

const authGuardOptions: IAuthGuardOptions = {
  permissions: [
    ...COMMON_GUARD_OPTIONS.OCR_QUOTATION_EXPIRATION_SETTINGS.VIEW.permissions,
    ...COMMON_GUARD_OPTIONS.OCR_QUOTATION_EXPIRATION_SETTINGS.SET.permissions,
  ],
  redirectTo: ExpirationSettingsRoutePaths.ROOT,
};

export const ocrQuotationExpirationSettingsRoutes: Routes = [
  {
    path: OcrQuotaitonExpirationSettingsRoutePaths.ROOT,
    loadComponent: () =>
      import("./pages/ocr-quotaiton-expiration-settings/ocr-quotaiton-expiration-settings.component").then(
        t => t.OcrQuotaitonExpirationSettingsComponent
      ),
    resolve: {
      ocrQuotationExpirationSettings: ocrQuotationExpirationSettingsResolver,
    },
    canActivate: [AuthGuard],
    data: { authGuardOptions },
  },
];
